'use client';

import { useState, useEffect } from 'react';
import GenreFilter from './GenreFilter';
import BookGrid from './BookGrid';

export default function BookListInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [selectedGenre, setSelectedGenre] = useState('all');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-6 py-12">
      <GenreFilter 
        selectedGenre={selectedGenre}
        onGenreChange={setSelectedGenre}
      />
      <div className="mt-12">
        <BookGrid selectedGenre={selectedGenre} />
      </div>
    </div>
  );
}